














































import { mapState, mapActions } from 'vuex'
import { tools } from 'src/utils'
import config from '@/config/defaultSettings'
import RouteView from './RouteView'
import SideMenu from 'src/components/layouts/menu/SideMenu.vue';
import GlobalHeader from '@/components/layouts/globalHeader';
import GlobalFooter from '@/components/layouts/globalFooter';
import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";

@Component({
  components:{
    RouteView,
    SideMenu,
    GlobalHeader,
    GlobalFooter
  }
})
export default class BasicLayout extends Vue
{

    /**
     * 是否展开菜单
     * @member
     * @returns boolan
     */
    private collapsed: boolean = false;

    /**
     * 菜单列表
     * @member
     * @returns boolan
     */
    private menus: Array<any> = [];

    /**
     * 菜单列表
     * @member
     * @returns boolan
     */
    private get mainMenu(): Array<any>
    {
        return this.$store.getters["global/menuData"]
    }

    /**
     * 菜单左边距离
     * @member
     * @returns string
     */
    protected get contentPaddingLeft(): string
    {
        
        if (!this.collapsed)
        {
            return '230px'
        }
        return '80px'
    }

    /**
     * 监听菜单数据变化
     * @prprivate
     */
    @Watch("mainMenu")
    private onMainMenuChange()
    {
        this.setMenus()
    }

    /**
     * 组件创建钩子
     * @prprivate
     */
    private created():void
    {
        this.setMenus()
        // this.collapsed = !this.sidebarOpened
    }

    private mounted ()
    {
        const userAgent = navigator.userAgent
        if (userAgent.indexOf('Edge') > -1) {
            this.$nextTick(() => {
                this.collapsed = !this.collapsed
                setTimeout(() => {
                    this.collapsed = !this.collapsed
                }, 16)
            })
        }
    }

    private convertRoutes (nodes: any) {
        if (!nodes) return null

        nodes = JSON.parse(JSON.stringify(nodes))

        let queue = Array.isArray(nodes) ? nodes.concat() : [nodes]

        while (queue.length)
        {
            const levelSize = queue.length

            for (let i = 0; i < levelSize; i++)
            {
                const node = queue.shift()

                if (!node.children || !node.children.length) continue

                node.children.forEach((child: any) =>
                {
                    // 转化相对路径
                    if (child.path[0] !== '/' && !child.path.startsWith('http'))
                    {
                        child.path = node.path.replace(/(\w*)[/]*$/, `$1/${child.path}`)
                    }
                })

                queue = queue.concat(node.children)
            }
        }

        return nodes
    }

    /**
     * 设置菜单数据
     * @protected
     * @returns void
     */
    protected setMenus(): void
    {
        const routes = this.convertRoutes(this.mainMenu.find(item => item.path === '/'))
        this.menus = (routes && routes.children) || []
    }

    /**
     * 菜单切换
     * @protected
     */
    protected toggle()
    {
        this.collapsed = !this.collapsed
        this.$store.dispatch("config/setSidebar", !this.collapsed)
        tools.triggerWindowResizeEvent()
    }

    /**
     * 菜单选择
     * @protected
     * @returns void
     */
    protected menuSelect(data: any): void
    {
        this.$router.push({path:data.key})
    }

    /**
     * 关闭配置面板
     * @protected
     * @returns void
     */
    protected drawerClos(): void
    {
        this.collapsed = false
    }
}
